import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex: 1;\n  gap: 8px;\n  float: right;\n  justify-content: flex-end;\n  button {\n    all: unset;\n    width: 32px;\n    height: 32px;\n    border-radius: 4px; //2px\n    border: 1px solid ",
        ";\n    background-color: ",
        ";\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    &.swiper-button-disabled {\n      border: 0;\n      background-color: ",
        ";\n      opacity: 0.4;\n    }\n    :hover,\n    :active {\n      background-color: ",
        ";\n    }\n  }\n  @media (max-width: 1200px) {\n    display: none;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowLeft, ArrowRight, Sizes } from "@/components/icon/IconList";
import React from "react";
import styled, { useTheme } from "styled-components";
import Icon from "../icon/Icon";
export const SwiperCustomButton = (param)=>{
    let { nextClassName , prevClassName  } = param;
    const theme = useTheme();
    return /*#__PURE__*/ _jsxs(SwiperCustomButtonWrapper, {
        children: [
            /*#__PURE__*/ _jsx("button", {
                className: prevClassName,
                children: /*#__PURE__*/ _jsx(Icon, {
                    icon: ArrowLeft,
                    size: Sizes.small,
                    color: theme.new.colors.sol_gray_900
                })
            }),
            /*#__PURE__*/ _jsx("button", {
                className: nextClassName,
                children: /*#__PURE__*/ _jsx(Icon, {
                    icon: ArrowRight,
                    size: Sizes.small,
                    color: theme.new.colors.sol_gray_900
                })
            })
        ]
    });
};
const SwiperCustomButtonWrapper = styled.div.withConfig({
    componentId: "sc-eefc77c1-0"
})(_templateObject(), (props)=>props.theme.new.colors.sol_gray_200, (props)=>props.theme.new.colors.white, (props)=>props.theme.new.colors.sol_gray_0, (props)=>props.theme.new.colors.sol_gray_100);
